import { AccessType } from '@atomica.co/irori';
import { Labels } from '../models/common-model';

export const ACCESS_LABELS: Labels = {
  [AccessType.IN]: '入室',
  [AccessType.OUT]: '退室'
};
